import { useShortcutKeys } from "hooks";
import {
  AddWidgetAccountName,
  BuyAndSell,
  Checkout,
  CICO,
  FiatAccount,
  KycStatus,
  // TransferHistoryDetails,
  Pay,
  Payment,
  PayReference,
  Registration,
  RemoveSuspension,
  Transaction,
  // Verification,
  TransferHistory,
  Transfers,
} from "pages";
import PaymentSuccessView from "pages/BuyAndSell/PaymentSuccessView";
import { VerificationWrapper } from "pages/BuyAndSell/Verification";
import OTCCheckIn from "pages/OTCCheckIn/checkin";
import { Route, Routes, useLocation } from "react-router";
import ls from "utils/secureStorage";

export function AppRouter(props: any) {
  const { pathname } = useLocation();

  const switchModule = (key: string) => {
    if (key === "wc" && pathname !== "/cico") {
      ls.set("module", "wc");
      window.location.replace(`/cico`);
    }

    if (key === "wp") {
      ls.set("module", "wp");
      window.location.replace(`/`);
      // window.location.replace(`${pathname}${search}`);
    }
  };

  // workspace pay
  useShortcutKeys({ shortcutSequences: ["/", "w", "p"], cb: () => switchModule("wp") });
  // workspace cico
  useShortcutKeys({ shortcutSequences: ["/", "w", "c"], cb: () => switchModule("wc") });
  // clear local storage
  useShortcutKeys({ shortcutSequences: ["/", "c", "l", "s"], cb: () => ls.clear() });

  return (
    <Routes>
      {/* <NotFound path="/404" /> */}

      <Route path="/" element={<BuyAndSell />} />
      <Route path="/otc" element={<OTCCheckIn />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/payment/:id" element={<PaymentSuccessView />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/partner-user-verification" element={<Checkout isPartner />} />

      <Route path="/transfers" element={<Transfers />} />
      <Route path="/kyc" element={<Registration />} />
      <Route path="/transaction/:id" element={<Transaction />} />

      <Route path="/verification" element={<VerificationWrapper />} />
      {/* <Route path="/partner-verification" element={<PartnerVerification />} /> */}

      <Route path="/account-name" element={<AddWidgetAccountName />} />
      <Route path="/fiat-account" element={<FiatAccount />} />

      <Route path="/transfer-history" element={<TransferHistory />} />
      <Route path="/transfer-history/:id" element={<Transaction />} />

      <Route path="/kyc-status" element={<KycStatus />} />
      <Route path="/auth-reset" element={<RemoveSuspension />} />

      <Route path="/pay" element={<Pay />} />
      <Route path="/pay/:id" element={<PayReference />} />

      <Route path="/cico" element={<CICO />} />

      {/* <Layout path="/">
        <RootPage path="/">
          <NoMatch default noThrow to="/404" />
        </RootPage>

        <RootPage path="/checkout">
          <NoMatch default noThrow to="/404" />
        </RootPage>

        <RootPage path="/register">
          <NoMatch default noThrow to="/404" />
          <Registration path="/" />
        </RootPage>

        <RootPage path="verification">
          <NoMatch default noThrow to="/404" />
          <Verification path="/" />
        </RootPage>

        <RootPage path="payment">
          <NoMatch default noThrow to="/404" />
          <Payment path="/" />
        </RootPage>
        <RootPage path="transaction">
          <NoMatch default noThrow to="/404" />
          <Transaction path="/" />
        </RootPage>
      </Layout> */}
    </Routes>
  );
}
